<template>
  <v-card outlined class="mx-1" v-if="mobileBereakPoint">
    <v-card-text>
      <v-expansion-panels flat accordion v-model="panel" tile>
        <v-expansion-panel >
          <v-expansion-panel-header class="clearExpansinHeaderPadding">{{ labels.options }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col class="clearColumnPadding mb-2">
              <v-autocomplete
                dense
                outlined
                :items="poiDropdown"
                item-text="name"
                item-value="name"
                :label="labels.selectPoi"
                v-model="selectedPoi"
                hide-details
              ></v-autocomplete>
              <v-card-text class="error--text">{{additionalErrors}}</v-card-text>
            </v-col>
            <FilterBuilder
              :alreadyExistingSearchObject="reportRequestObject"
              @apiResponded="findRetroactivePoiEnters"
              @errorOccured="setErrors"
              :endPoint="'reports/RetroactivePoiEntrance'"
              :formElements="elements"
              @externalErrorsHappend="addAditionalErrors"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
  <v-card outlined class="mr-3" v-else>
    <v-card-text>
      <template>
        <v-col class="clearColumnPadding my-2" >
          <h4 class="font-weight-light pt-2">{{ labels.options }}</h4>
        </v-col>
        <v-col class="clearColumnPadding mb-2">
          <v-autocomplete
            dense
            outlined
            :items="poiDropdown"
            item-text="name"
            item-value="name"
            :label="labels.selectPoi"
            v-model="selectedPoi"
            hide-details
          ></v-autocomplete>
          <v-card-text class="error--text">{{additionalErrors}}</v-card-text>
        </v-col>
        <FilterBuilder
          :alreadyExistingSearchObject="reportRequestObject"
          @apiResponded="findRetroactivePoiEnters"
          @errorOccured="setErrors"
          :endPoint="'reports/RetroactivePoiEntrance'"
          :formElements="elements"
          @externalErrorsHappend="addAditionalErrors"
        />
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import EventBus from '../../../event-bus'
import translate from '@/utils/genTable/multilanguageHelper.js'
import httpClient from '../../../api/httpClient'
import store from '@/store/store'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import FilterBuilder from '@/components/v2/FilterBuilder'
import formatDate from '@/utils/formatDateHelper.js'

export default {
  name: 'RetroactivePoiContainer',
  components: {
    ValidationProvider,
    ValidationObserver,
    TimeFilter: () => import('@/components/reports/TimeFilter'),
    VehicleSelector: () => import('@/components/VehicleSelectorComponent'),
    FilterBuilder
  },
  data() {
    return {
      additionalErrors: '',
      panel: 0,
      pois: [],
      showLoading: false,
      poiDropdown: [],
      vehicleDropdown: [],
      errors: null,
      selectedPoi: null,
      selectedVehicle: [],
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      reportRequestObject: {},
      error: false,
      labels: {
        btnTracking: translate('Show retroactive POI enters', 'mapFilters'),
        selectPoi: translate('Choose Poi *', 'mapFilters'),
        filters: translate('Filters', 'mapFilters'),
        options: translate('Options', 'mapFilters'),
        noData: translate('No data available', 'mapFilters')
      },
      objectToBeAttached: {},
      elements: [
        {
          key: 'Groups',
          affects: [
            {
              key: 'VehicleIds',
              change: {
                type: 'dataSource',
                api: {
                  endpoint: '/vehicles?GroupIds=',
                  associateValue: true
                }
              }
            }
          ],
          cols: 12,
          component: 'VSelectAll',
          dataSource: { endpoint: '/lookup/vehiclegroups' },
          label: '$groups',
          props: {
            multiple: true,
            onlyDeselect: true
          }
        },
        {
          key: 'VehicleIds',
          cols: 12,
          component: 'VSelectAll',
          rules: 'required',
          dataSource: { endpoint: '/vehicles' },
          label: '$vehicles'
        }
      ]
    }
  },
  mounted() {
    httpClient.get('/pois').then(response => (this.poiDropdown = response.data))

    EventBus.$on('TEMPORARY_POI', this.handleTemporaryPoi)
    EventBus.$on(
      'REMOVE_TEMPORARY_CIRCLE_POI_FROM_DROPDOWN',
      this.removeTemporaryCirlePoi
    )
    EventBus.$on(
      'REMOVE_TEMPORARY_POLYGON_POI_FROM_DROPDOWN',
      this.removeTemporaryPolygonPoi
    )
  },
  computed: {
    getCoordinatsFields() {
      let qs = {}
      let poiField = this.objectToBeAttached

      qs.Name = poiField.name

      for (let i = 0; i < poiField.coordinates.length; i++) {
        qs['Poi.Coordinates[' + i + '].Latitude'] =
          poiField.coordinates[i].latitude
        qs['Poi.Coordinates[' + i + '].Longitude'] =
          poiField.coordinates[i].longitude
      }

      if (poiField.type == 0) {
        qs['Poi.Radius'] = poiField.radius
      }

      return qs
    },
    mobileBereakPoint() {
      //sm and down
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    addAditionalErrors(errors) {
      this.additionalErrors = errors[0].error
    },
    handleTemporaryPoi(data) {
      if (!Array.isArray(data.coordinates)) {
        data.coordinates = [data.coordinates]
        data.type = 0
      } else {
        data.type = 1
      }

      data.coordinates.forEach(coordinate => {
        for (let prop in coordinate) {
          if (prop == 'lng') {
            coordinate['longitude'] = coordinate[prop]
            delete coordinate[prop]
          } else {
            coordinate['latitude'] = coordinate[prop]
            delete coordinate[prop]
          }
        }
      })

      data.name = `Temp POI - ${this.poiDropdown.length + 1}`

      this.poiDropdown.push(data)
    },
    setErrors(errors) {
      this.errors = errors
    },
    removeTemporaryCirlePoi(data) {
      this.poiDropdown.forEach((option, index) => {
        option.coordinates.forEach(point => {
          if (point.latitude == data.lat && point.longitude == data.lng) {
            this.poiDropdown.splice(index, 1)
          }
        })
      })
    },
    removeTemporaryPolygonPoi(data) {
      this.poiDropdown.forEach((option, index) => {
        option.coordinates.forEach(point => {
          if (
            point.latitude == data[0][0].lat &&
            point.longitude == data[0][0].lng
          ) {
            this.poiDropdown.splice(index, 1)
          }
        })
      })
    },
    findRetroactivePoiEnters(response) {
      this.panel = 1
      var that = this
      response.forEach(x => {
        x.poiName = that.selectedPoi
        x.poiLeftAt = formatDate(x.poiLeftAt, 'long', true)
        x.poiEnteredAt = formatDate(x.poiEnteredAt, 'long', true)
      })
      store.dispatch('retroactivePoi/setRetroactivePoiEnters', response)
    }
  },
  destroyed() {
    store.dispatch('retroactivePoi/setRetroactivePoiEnters', [])
  },
  watch: {
    selectedPoi: {
      handler() {
        this.additionalErrors = ''
        let choosenPoi = this.poiDropdown.find(x => x.name == this.selectedPoi)
        store.dispatch('map/showSinglePoi', choosenPoi)
        this.objectToBeAttached = choosenPoi
        if (choosenPoi != null) {
          this.reportRequestObject = this.getCoordinatsFields
        }
      }
    }
  }
}
</script>
<style scoped>
.clearColumnPadding {
  padding: 0px;
}
.clearExpansinHeaderPadding {
  padding: 0px;
  height: 48px !important;
  max-height: 62px;
  min-height: 48px;
}
</style>
<style>
.v-data-table .v-data-table__mobile-row {
  min-height: 14px !important;
}
</style>
